import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { showSpinner, hideSpinner } from 'action/spinner'

import {
  FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_REQUEST,
  FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_SUCCESS,
  FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_ERROR,
  UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_REQUEST,
  UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_SUCCESS,
  UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_ERROR,
  GET_PAGES,
} from 'actionTypes'

const getPages = (metadata) => ({
  type: GET_PAGES,
  pages: metadata.pageCount,
  current: metadata.page,
  count: metadata.totalCount,
})

export const fetchDemarcateDisapprovalJustificationList =
  (token, page = 1) =>
  (dispatch) => {
    dispatch(fetchDemarcateDisapprovalJustificationListRequest())
    const param = {
      page,
    }

    return new Api(token, dispatch)
      .get(API_URL.LIST_DEMARCATE_DISAPPROVAL_JUSTIFICATION, param)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(getPages(response.data.pagination))
        dispatch(
          fetchDemarcateDisapprovalJustificationListSuccess(
            response.data.listPresenter
          )
        )
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(fetchDemarcateDisapprovalJustificationListError(error))
        dispatch(hideSpinner())
      })
  }

export const fetchDemarcateDisapprovalJustificationListRequest = () => ({
  type: FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_REQUEST,
})

export const fetchDemarcateDisapprovalJustificationListSuccess = (data) => ({
  type: FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_SUCCESS,
  payload: data,
})

export const fetchDemarcateDisapprovalJustificationListError = (error) => ({
  type: FETCH_DEMARCATE_DISAPPROVAL_JUSTIFICATION_LIST_ERROR,
  payload: error,
})

export const updateDemarcateDisapprovalJustification =
  (token, values) => (dispatch) => {
    dispatch(updateDemarcateDisapprovalJustificationRequest())

    const fields = {
      ...values,
    }

    return new Api(token, dispatch)
      .post(API_URL.SAVE_DEMARCATE_DISAPPROVAL_JUSTIFICATION, fields)
      .then(dispatch(showSpinner()))
      .then((response) => {
        dispatch(updateDemarcateDisapprovalJustificationSuccess(response.data))
        dispatch(fetchDemarcateDisapprovalJustificationList(token))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(updateDemarcateDisapprovalJustificationError(error))
        dispatch(hideSpinner())
      })
  }

export const updateDemarcateDisapprovalJustificationRequest = () => ({
  type: UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_REQUEST,
})

export const updateDemarcateDisapprovalJustificationSuccess = (data) => ({
  type: UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_SUCCESS,
  payload: data,
})

export const updateDemarcateDisapprovalJustificationError = (error) => ({
  type: UPDATE_DEMARCATE_DISAPPROVAL_JUSTIFICATION_ERROR,
  payload: error,
})

export const removeDemarcateDisapprovalJustification =
  (token, id) => (dispatch) =>
    new Api(token, dispatch)
      .post(API_URL.REMOVE_DEMARCATE_DISAPPROVAL_JUSTIFICATION, id)
      .then(dispatch(showSpinner()))
      .then(() => {
        dispatch(fetchDemarcateDisapprovalJustificationList(token))
        dispatch(hideSpinner())
      })
      .catch((error) => {
        dispatch(updateDemarcateDisapprovalJustificationError(error))
        dispatch(hideSpinner())
      })
